export const Data = {
  cards:document.querySelectorAll('.p-data-card'),
  set(){
    this.cards.forEach(card => {
      const base = Number(getComputedStyle(card).getPropertyValue('--base').trim());
      const width = card.clientWidth;
      const times = Math.min(( width / base).toFixed(5) , 1 );
      card.style.setProperty('--times',times);
    });
  },
  init(){
    this.set();
  },
  resize(){
    this.set();
  }
}